(function () {
    function initialiseShopByCategory(section) {
      if (!section || section.dataset.sbcInitialised === 'true') return;
      section.dataset.sbcInitialised = 'true';

      var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-sbc-tab]'));
      var panels = Array.prototype.slice.call(section.querySelectorAll('[data-sbc-panel]'));
      var prevButton = section.querySelector('[data-sbc-prev]');
      var nextButton = section.querySelector('[data-sbc-next]');
      var resizeTimer;

      function activePanel() {
        return section.querySelector('.sbc-panel--active');
      }

      function activeRail() {
        var panel = activePanel();
        return panel ? panel.querySelector('[data-sbc-rail]') : null;
      }

      function updateArrows() {
        var rail = activeRail();
        if (!rail || !prevButton || !nextButton) return;

        var maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
        prevButton.disabled = rail.scrollLeft <= 4;
        nextButton.disabled = rail.scrollLeft >= maxScroll - 4 || maxScroll <= 4;
      }

      function scrollActiveRail(direction) {
        var rail = activeRail();
        if (!rail) return;

        var card = rail.querySelector('.sbc-card');
        var gap = parseFloat(window.getComputedStyle(rail).columnGap) || 18;
        var distance = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * .8;

        rail.scrollBy({
          left: direction * distance,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      function activateTab(key, moveFocus) {
        tabs.forEach(function (tab) {
          var selected = tab.getAttribute('data-sbc-tab') === key;
          tab.classList.toggle('sbc-tab--active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          if (selected && moveFocus) tab.focus();
        });

        panels.forEach(function (panel) {
          var selected = panel.getAttribute('data-sbc-panel') === key;
          panel.classList.toggle('sbc-panel--active', selected);
          panel.hidden = !selected;
          if (selected) {
            var rail = panel.querySelector('[data-sbc-rail]');
            if (rail) rail.scrollLeft = 0;
          }
        });

        var selectedTab = section.querySelector('[data-sbc-tab="' + key + '"]');
        if (selectedTab) {
          selectedTab.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }

        requestAnimationFrame(updateArrows);
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activateTab(tab.getAttribute('data-sbc-tab'), false);
        });

        tab.addEventListener('keydown', function (event) {
          var targetIndex = index;

          if (event.key === 'ArrowRight') targetIndex = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') targetIndex = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') targetIndex = 0;
          else if (event.key === 'End') targetIndex = tabs.length - 1;
          else return;

          event.preventDefault();
          activateTab(tabs[targetIndex].getAttribute('data-sbc-tab'), true);
        });
      });

      panels.forEach(function (panel) {
        var rail = panel.querySelector('[data-sbc-rail]');
        if (rail) rail.addEventListener('scroll', updateArrows, { passive: true });
      });

      if (prevButton) prevButton.addEventListener('click', function () { scrollActiveRail(-1); });
      if (nextButton) nextButton.addEventListener('click', function () { scrollActiveRail(1); });

      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateArrows, 120);
      });

      requestAnimationFrame(updateArrows);
    }

    function initialiseAll(root) {
      var scope = root || document;
      if (scope.matches && scope.matches('.sbc-section')) {
        initialiseShopByCategory(scope);
      }
      Array.prototype.forEach.call(scope.querySelectorAll ? scope.querySelectorAll('.sbc-section') : [], initialiseShopByCategory);
    }

    window.BigsmallShopByCategoryInit = initialiseAll;
    initialiseAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      initialiseAll(event.target);
    });
  })();
